import { usePixelLoader } from '~/hooks/usePixelLoader';

interface ScriptProps {
  pixelId: string;
  dataProcessingCookies: boolean;
}

export const GTMScript = ({ pixelId, dataProcessingCookies }: ScriptProps) => {
  usePixelLoader(() => {
    // match valid pixel id: GTM- followed by 5+ alphanumeric chars
    if (pixelId?.match(/^GTM-[A-Z0-9]{5,}$/) && dataProcessingCookies) {
      const script = document.createElement('script');
      script.id = 'gtm-pixel';
      script.innerHTML = `
          (function(){try{
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${pixelId}');
          }catch{/*swallow exception*/}})();
            `;
      document.head.appendChild(script);
    }
  }, [pixelId, dataProcessingCookies]);

  return null;
};

interface PixelProps {
  pixelId: string;
}

export const GTMPixel = ({ pixelId }: PixelProps) => {
  usePixelLoader(() => {
    if (pixelId) {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${pixelId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      document.head.appendChild(iframe);
    }
  }, [pixelId]);

  return null;
};
